import { useEffect, useState, useMemo } from 'react'

import { FormControl, InputLabel, Select, Box, MenuItem, Button, Popper, Fade, Paper, ClickAwayListener } from '@mui/material'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import SearchIcon from '@mui/icons-material/Search'
import ViewKanbanIcon from '@mui/icons-material/ViewKanban'
import TableRowsIcon from '@mui/icons-material/TableRows'

import Loading from '../Loading'

import { getSession } from "../../auth"
import api from "../../api"


import dayjs from 'dayjs'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { DateTimePicker } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { ptBR as adapterptBR } from 'dayjs/locale/pt-br'
import { ptBR as localePTBR } from '@mui/x-date-pickers/locales'
import { ptBR as corePtBR } from '@mui/material/locale';
import LoadingButton from '@mui/lab/LoadingButton';
import './styles.css'
import { number2dayweek } from '../Report/NewDetailedRegister/detailed_register_leftmenu'

import {
    DataGridPro,
    ptBR
} from '@mui/x-data-grid-pro';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { formatCurrency, generateExport, applyBoundColors, BOUND_COLORS } from './functions'
import { currencyPrefix } from './single-card'
import DashboardCard from './mechanisms/card'
import { platformIcon } from '../Report/NewDetailedRegister/contact_graph_exception'
import { convert_seconds } from '../Dash/HistoricDash/graphs/charts'
import LostOpportunitiesDashboard from './Graphs/lostopportunities'
import ClosedOpportunitiesDashboard from './Graphs/closedopportunities'
import QualifiedOpportunitiesDashboard from './Graphs/qualifiedopportunities'
import DelayedSales from './Graphs/delayedsales'
import EstimatedSales from './Graphs/estimatedsales'
import JourneyOpportunitiesDashboard from './Graphs/journeyopportunities'
import CommunicationSalesDashboard from './Graphs/communicationssales'
import DownloadIcon from '@mui/icons-material/Download';
import ConversionRateDashboard from './Graphs/conversionrate'

const theme = createTheme({
    palette: {
        primary: { main: '#21446C' },
    },
}, ptBR, corePtBR);

const types = {
    day: 'Dia',
    range: 'Intervalo',
    month: 'Mês',
    thismonth: 'Mês atual',
    thistrimester: 'Trimestre atual',
    thisyear: 'Ano atual',
    lastmonth: 'Mês anterior',
    lasttrimester: 'Trimestre anterior',
    lastyear: 'Ano anterior'
}

const reports = {
    'opportunities': 'Oportunidades',
    'communications': 'Comunicações',
}

export const translateStatus = {
    'ACTIVE': "Ativo",
    'INACTIVE': "Inativo",
    'QUALIFIED': "Qualificada",
    'CONQUERED': "Conquistada",
    'LOST': 'Perdida'
}

const views = {
    //'reports': () => ({ label: 'Relatório detalhado' }),
    'lostxseller': (data) => ({ label: 'Oportunidades Perdidas x Vendedor', component: <LostOpportunitiesDashboard data={data?.opportunities_by_status} /> }),
    'communicationxseller': (data) => ({ label: 'Comunicações x Vendedor', component: <CommunicationSalesDashboard data={data?.communications} /> }),
    'closedxseller': (data) => ({ label: 'Oportunidades Conquistadas x Vendedor', component: <ClosedOpportunitiesDashboard data={data?.opportunities_by_status} /> }),
    'qualifiedxseller': (data) => ({ label: 'Oportunidades Qualificadas x Vendedor', component: <QualifiedOpportunitiesDashboard data={data?.opportunities_by_status} /> }),
    'delayedsales': (data) => ({ label: 'Oportunidades Atrasadas', component: <DelayedSales data={data?.opportunities} /> }),
    'salesestimate': (data) => ({ label: 'Estimativa de vendas', component: <EstimatedSales data={data?.opportunities} /> }),
    'journeyopportunities': (data) => ({ label: 'Oportunidades por jornada', component: <JourneyOpportunitiesDashboard data={data?.opportunities} /> }),
    'qualifiedjourneyopportunities': (data) => ({ label: 'Oportunidades Qualificadas por jornada', component: <JourneyOpportunitiesDashboard data={data?.opportunities_by_status} status='QUALIFIED' name='qualifiedjourneyopportunities' /> }),
    'conqueredjourneyopportunities': (data) => ({ label: 'Oportunidades Conquistadas por jornada', component: <JourneyOpportunitiesDashboard data={data?.opportunities_by_status} status='CONQUERED' name='conqueredjourneyopportunities' /> }),
    'conversionratejourneyopportunities': (data) => ({ label: 'Taxa de conversão por jornada', component: <ConversionRateDashboard data={data?.conversion_rate_by_journey} /> })
}



const generateOpportunitiesColumns = (report) => {
    const columns = []

    columns.push({ field: "title", headerName: "Oportunidade", flex: 1 })
    columns.push({ field: "journey_name", headerName: "Jornada", flex: 1 })
    columns.push({ field: "owner_name", headerName: "Vendedor", flex: 1 })
    columns.push({ field: "column_name", headerName: "Estágio", flex: 1 })
    columns.push({
        field: "value", headerName: "Valor", flex: 1,
        renderCell: ({ value, row }) => `${currencyPrefix[row?.currency]} ${formatCurrency(String(value), row?.currency)}`
    })
    columns.push({
        field: "status", headerName: "Status", flex: 1,
        renderCell: ({ value }) => translateStatus[value]
    })
    columns.push({
        field: "created_at", headerName: "Criação", flex: 1,
        renderCell: ({ value }) => value ? dayjs.utc(value).local().format('DD/MM/YYYY HH:mm') : ""
    })
    columns.push({
        field: "estimated_at", headerName: "Estimada em", flex: 1,
        renderCell: ({ value }) => value ? dayjs.utc(value).local().format('DD/MM/YYYY HH:mm') : ""
    })
    columns.push({
        field: "closed_at", headerName: "Fechada em", flex: 1,
        renderCell: ({ value }) => value ? dayjs.utc(value).local().format('DD/MM/YYYY HH:mm') : ""
    })


    return columns
}

const generateCommunicationColumns = () => {
    const columns = []
    columns.push({
        field: "date", headerName: "Data", flex: 1,
        renderCell: ({ row }) => dayjs(`${row.date}T${row.time}`).format('DD/MM/YYYY HH:mm')
    })
    columns.push({ field: "agent_name", headerName: "Vendedor", flex: 1 })
    columns.push({ field: "origin", headerName: "Origem", flex: 1 })
    columns.push({ field: "destination", headerName: "Destino", flex: 1 })
    columns.push({
        field: "duration", headerName: "Duração", flex: 1, renderCell: ({ value }) => (
            convert_seconds(value)
        )
    })
    columns.push({ field: "platform_entrypoint", headerName: "Canal", width: 30, renderCell: ({ value }) => platformIcon(value) })
    return columns
}

const getJourneyReport = async (state, setState) => {
    setState(p => ({ ...p, loading: true }))
    const enterpriseId = getSession().profile.enterprise.id
    const { rows, columns, ...payload } = state
    const res = await api.post(`api/enterprises/${enterpriseId}/journeys/report/`, payload)
    const response = { loading: false }
    if (res.status === 200) {
        response.generated_report = state.report
        response.opportunities = res.data.opportunities
        response.opportunities_by_status = res.data.opportunities_by_status
        response.conversion_rate_by_journey = res.data.conversion_rate_by_journey
        response.communications = res.data.communications
        const allOwners = [
            ...response.opportunities.map(o => o.owner_name),
            ...response.opportunities_by_status.map(o => o.owner_name),
            ...response.opportunities.map(o => o.journey_name),
            ...response.opportunities_by_status.map(o => o.journey_name),
            ...(response.conversion_rate_by_journey || []).map(o => o.owner_name),
            ...(response.conversion_rate_by_journey || []).map(o => o.journey_name),
        ]
        applyBoundColors(allOwners)
    }

    setState(p => ({ ...p, ...response }))
}

const JourneyDashboard = ({ allUsers, journeys, handleClose }) => {

    const [state, setState] = useState({
        loading: false,
        type: 'day',
        day: dayjs(),
        range_ini: dayjs().subtract(1, 'month'),
        range_end: dayjs(),
        month: dayjs(),
        sellers: [],
        journeys: [],
        report: Object.keys(reports)[0] || '',
        generated_report: '',
        opportunities: [],
        opportunities_by_status: [],
        conversion_rate_by_journey: [],
        communications: [],
        views: JSON.parse(localStorage.getItem('journey-main-views')) || Object.keys(views),
        showExportButtons: false,
        anchorEl: null
    })

    const views_list = useMemo(() => Object.entries(views), [state.opportunities, state.communications, state.views])

    const dashviews = useMemo(() => views_list.flatMap(([key, func]) => {
        if (key === 'reports' || !state.views.includes(key)) return []
        const item = func(state)
        return (
            <DashboardCard label={item.label} save={key}>{item.component}</DashboardCard>
        )
    }), [views_list])

    return (
        <>
            <Loading loading={state.loading} />
            <Box className='main-journay-wrapper'>
                <Box className="journey-dashboard-toolbar" sx={{ display: "flex", gap: "1rem", padding: "1rem 1rem 0 1rem" }}>
                    <Button className="kanban-btn" onClick={handleClose}>
                        <ArrowBackIcon />
                        Voltar
                    </Button>
                    <LocalizationProvider
                        sx={{ justifyContent: 'space-between' }}
                        dateAdapter={AdapterDayjs}
                        adapterLocale={adapterptBR}
                        localeText={
                            localePTBR.components.MuiLocalizationProvider.defaultProps.localeText
                        }
                    >
                        <Box className='graph-reports-filter'>
                            <FormControl size='small' sx={{ minWidth: '10rem', maxWidth: '10rem' }}>
                                <InputLabel id='report-type-report'>Visualizações</InputLabel>
                                <Select
                                    multiple={true}
                                    labelId='report-type-views'
                                    id='views-type-views-select'
                                    value={state.views}
                                    label='Visualizações'
                                    onChange={e => {
                                        setState(p => ({ ...p, views: e.target.value }))
                                        localStorage.setItem('journey-main-views', JSON.stringify(e.target.value))
                                    }}
                                >
                                    {views_list.map(([key, value]) => (
                                        <MenuItem value={key}>{value().label}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            {state.views.includes('reports') && <FormControl size='small' sx={{ minWidth: '10rem', maxWidth: '10rem' }}>
                                <InputLabel id='report-type-report'>Relatório</InputLabel>
                                <Select
                                    labelId='report-type-report'
                                    id='report-type-report-select'
                                    value={state.report}
                                    label='Relatório'
                                    onChange={e => setState(p => ({ ...p, report: e.target.value }))}
                                >
                                    {Object.entries(reports).map(([key, value]) => (
                                        <MenuItem value={key}>{value}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>}
                            <FormControl size='small' sx={{ minWidth: '10rem', maxWidth: '10rem' }}>
                                <InputLabel id='report-type-journey'>Jornada(s)</InputLabel>
                                <Select
                                    multiple={true}
                                    labelId='report-type-journey'
                                    id='report-type-journey-select'
                                    value={state.journeys}
                                    label='Jornada(s)'
                                    onChange={e => setState(p => ({ ...p, journeys: e.target.value }))}
                                >
                                    {journeys.map((journey) => (
                                        <MenuItem value={journey.id}>{journey.name}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <FormControl size='small' sx={{ minWidth: '10rem', maxWidth: '10rem' }}>
                                <InputLabel id='report-type-seller'>Vendedor(es)</InputLabel>
                                <Select
                                    multiple={true}
                                    labelId='report-type-seller'
                                    id='report-type-seller-select'
                                    value={state.sellers}
                                    label='Vendedor(es)'
                                    onChange={e => setState(p => ({ ...p, sellers: e.target.value }))}
                                >
                                    {allUsers.map((user) => (
                                        <MenuItem value={user.id}>{user.first_name} {user.last_name}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <FormControl size='small' sx={{ minWidth: '10rem' }}>
                                <InputLabel id='report-type'>Período</InputLabel>
                                <Select
                                    labelId='report-type'
                                    id='report-type'
                                    value={state.type}
                                    label='Período'
                                    onChange={e => setState(p => ({ ...p, type: e.target.value }))}
                                >
                                    {Object.entries(types).map(([key, value]) => (
                                        <MenuItem value={key}>{value}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            {state.type === 'day' && (
                                <DatePicker
                                    sx={{ width: '100%', maxWidth: '10rem' }}
                                    label={'Dia'}
                                    views={['day', 'month', 'year']}
                                    format={'DD/MM/YYYY'}
                                    slotProps={{ textField: { size: 'small' } }}
                                    value={state.day}
                                    onChange={e => setState(p => ({ ...p, day: e }))}
                                    dayOfWeekFormatter={(n, date) => number2dayweek[date.$W]}
                                />
                            )}
                            {state.type === 'range' && (
                                <>
                                    <DateTimePicker
                                        sx={{ width: '100%', maxWidth: '13rem' }}
                                        label={'De'}
                                        views={['day', 'month', 'year', 'hours', 'minutes']}
                                        format={'DD/MM/YYYY HH:mm'}
                                        slotProps={{ textField: { size: 'small' } }}
                                        value={state.range_ini}
                                        onChange={e => setState(p => ({ ...p, range_ini: e }))}
                                        ampm={false}
                                        dayOfWeekFormatter={(n, date) => number2dayweek[date.$W]}
                                    />
                                    <DateTimePicker
                                        sx={{ width: '100%', maxWidth: '13rem' }}
                                        label={'Até'}
                                        views={['day', 'month', 'year', 'hours', 'minutes']}
                                        format={'DD/MM/YYYY HH:mm'}
                                        slotProps={{ textField: { size: 'small' } }}
                                        value={state.range_end}
                                        onChange={e => setState(p => ({ ...p, range_end: e }))}
                                        ampm={false}
                                        dayOfWeekFormatter={(n, date) => number2dayweek[date.$W]}
                                    />
                                </>
                            )}
                            {state.type === 'month' && (
                                <DatePicker
                                    sx={{ width: '100%', maxWidth: '13rem' }}
                                    label={'Mês e ano'}
                                    views={['month', 'year']}
                                    format={'MMMM, YYYY'}
                                    slotProps={{ textField: { size: 'small' } }}
                                    value={state.month}
                                    onChange={e => setState(p => ({ ...p, month: e }))}
                                    dayOfWeekFormatter={(n, date) => number2dayweek[date.$W]}
                                />
                            )}

                            <LoadingButton
                                onClick={() => {
                                    getJourneyReport(state, setState)
                                }}
                                loadingPosition='start'
                                loading={false}
                                variant='contained'
                                startIcon={<TableRowsIcon />}
                            >
                                Gerar
                            </LoadingButton>

                            <LoadingButton
                                onClick={(event) => {
                                    setState(p => ({ ...p, showExportButtons: true, anchorEl: event.currentTarget }))
                                }}
                                loadingPosition='start'
                                loading={false}
                                variant='contained'
                                startIcon={<DownloadIcon />}
                            >
                                Exportar
                            </LoadingButton>

                            <Popper
                                sx={{ zIndex: 1200 }}
                                open={state.showExportButtons}
                                anchorEl={state.anchorEl}
                                placement={'bottom-start'}
                            >
                                <ClickAwayListener onClickAway={() => setState(p => ({ ...p, showExportButtons: false, anchorEl: null }))}>
                                    <Paper>
                                        <Box className='journey-buttom-multiselect-list'>
                                            <LoadingButton
                                                onClick={() => {
                                                    generateExport({ opportunities: state.opportunities, communications: state.communications }, 'csv')
                                                }}
                                                loadingPosition='start'
                                                loading={false}

                                                startIcon={<DownloadIcon />}
                                            >
                                                CSV
                                            </LoadingButton>
                                            <LoadingButton
                                                onClick={() => {
                                                    generateExport({ opportunities: state.opportunities, communications: state.communications }, 'xlsx')
                                                }}
                                                loadingPosition='start'
                                                loading={false}
                                                startIcon={<DownloadIcon />}
                                            >
                                                XLSX
                                            </LoadingButton>
                                        </Box>
                                    </Paper>
                                </ClickAwayListener>
                            </Popper>

                        </Box>
                    </LocalizationProvider>
                </Box >
                <Box className='journey-dashboard-wrapper'>
                    {state.views.includes('reports') &&
                        <Box sx={{ width: '100%', padding: '0.5rem', height: '100%', flex: 1 }}>
                            <ThemeProvider theme={theme}>
                                {state.report === 'opportunities' && <DataGridPro
                                    columns={generateOpportunitiesColumns(state.report)}
                                    rows={state.opportunities}
                                    disableSelectionOnClick
                                    density={'compact'}
                                />}
                                {state.report === 'communications' &&
                                    <DataGridPro
                                        columns={generateCommunicationColumns(state.report)}
                                        rows={state.communications}
                                        disableSelectionOnClick
                                        density={'compact'}
                                    />
                                }
                            </ThemeProvider>
                        </Box>}
                    {dashviews.length > 0 &&
                        <Box className='journey-dashboard-grid'>
                            {dashviews}
                        </Box>}
                </Box>
            </Box >
        </>
    )
}


export default JourneyDashboard
